import moment from 'moment-timezone';
import {reactive} from "@vue/reactivity";
import {$t} from "@/i18n";

class DateHelper {

  public getUserTimeZone(): string {
    return window.userTimeZone ?? 'UTC';
  }

  public format(date: string | null, format: string | null = null, defaultValue: string = '', timezone: string|null = null) : string {
    if (date === null) {
      return defaultValue;
    }

    return (moment(date)).utcOffset(0).tz(timezone ?? (this.getUserTimeZone())).format(format ?? 'YYYY-MM-DD HH:mm');
  }

  toUTC(date: string|null, format: string | null = null, fromTimezone: string|null = null): string|null {
    if (!date) {
      return null;
    }

    return moment.tz(date, fromTimezone ?? (this.getUserTimeZone())).tz('UTC').format(format ?? 'YYYY-MM-DD HH:mm:ss');
  }
}

export const userTimeZone = (): string =>  {
  return window.userTimeZone
      ?? Intl.DateTimeFormat().resolvedOptions().timeZone
      ?? 'UTC';
}

export const dateHelper = new DateHelper();

export const nowState = reactive({
  now: Date.now() as number,
  nowUpdateInterval: null as number|any,
});

export const timeLeftLabelText = (date: string) => {
  const m = (moment(date)).utcOffset(0).tz(userTimeZone())

  const seconds = m.diff(moment(nowState.now), "seconds");
  if (seconds < 60) return $t('time_left.seconds', {seconds: Math.max(0, seconds)});

  const minutes = m.diff(moment(nowState.now), "minutes");
  if (minutes < 60) return $t('time_left.minutes', {minutes});

  const hours = m.diff(moment(nowState.now), "hours");
  if (hours < 24) return $t('time_left.hours', {hours});

  const days = m.diff(moment(nowState.now), "days");

  return $t('time_left.days', {days});
}

export const endedLabelText = (date: string) => {
  const m = (moment(date)).utcOffset(0).tz(userTimeZone())
  const now = moment(nowState.now);

  const seconds = now.diff(m, "seconds");
  if (seconds < 60) return $t('ended_at.seconds', {seconds: Math.max(0, seconds)});

  const minutes = now.diff(m, "minutes");
  if (minutes < 60) return $t('ended_at.minutes', {minutes});

  const hours = now.diff(m, "hours");
  if (hours < 24) return $t('ended_at.hours', {hours});

  const days = now.diff(m, "days");

  return $t('ended_at.days', {days});
}

export const startInLabelText = (date: string) => {
  const m = (moment(date)).utcOffset(0).tz(userTimeZone())

  const seconds = m.diff(moment(nowState.now), "seconds");
  if (seconds < 60) return $t('start_in.seconds', {seconds: Math.max(0, seconds)});

  const minutes = m.diff(moment(nowState.now), "minutes");
  if (minutes < 60) return $t('start_in.minutes', {minutes});

  const hours = m.diff(moment(nowState.now), "hours");
  if (hours < 24) return $t('start_in.hours', {hours});

  const days = m.diff(moment(nowState.now), "days");

  return $t('start_in.days', {days});
}

export const recalculationInLabelText = (date: string) => {
  const m = (moment(date)).utcOffset(0).tz(userTimeZone())

  const seconds = m.diff(moment(nowState.now), "seconds");
  if (seconds < 60) return $t('league_next_calc_at.seconds', {seconds: Math.max(0, seconds)});

  const minutes = m.diff(moment(nowState.now), "minutes");
  if (minutes < 60) return $t('league_next_calc_at.minutes', {minutes});

  const hours = m.diff(moment(nowState.now), "hours");
  if (hours < 24) return $t('league_next_calc_at.hours', {hours});

  const days = m.diff(moment(nowState.now), "days");

  return $t('league_next_calc_at.days', {days});
}